import { BaseSerializer } from "./baseSerializer";
import { Launches } from "../launches.model.ts";


export class LaunchesSerializer extends BaseSerializer {

    public deserialize( data: any ): any {

        const gp = new Launches();

        this._copyAttributes(gp, data);

        return gp;

    }

}
